import { generatePagerProps } from '@fukuri-admins/utils/common/generatePagerProps';
import { useInternalNewsList } from './hooks';
import { convertToInternalNewsListProps } from './logics';
import { InternalNewsListPresentation } from './presentations';
import { InternalNewsListEmptyPresentation } from './presentations/empty';

/**
 * 社内報一覧 Container コンポーネント
 */
export const InternalNewsList: React.FC = () => {
  const {
    state: { data, currentPage, totalPage, totalCount },
    actions: { handleEditClick, handleDeleteClick, handleDetailClick, handlePageChange },
  } = useInternalNewsList();

  const { items, isEmpty } = convertToInternalNewsListProps({ data });

  const pagerProps = generatePagerProps({
    currentPage,
    totalPage,
    totalCount,
    rows: data.client_newsletters,
    onPageChange: handlePageChange,
  });

  return isEmpty ? (
    <InternalNewsListEmptyPresentation />
  ) : (
    <InternalNewsListPresentation
      items={items}
      onEdit={handleEditClick}
      onDelete={handleDeleteClick}
      onDetailClick={handleDetailClick}
      pagerProps={pagerProps}
    />
  );
};
